<template>
	<div style="width: 100%;height: 100vh;">
		<el-image class="top-img" :src="topImage" fit="cover"></el-image>
		<div class="container" style="margin-top: 10px;">
			<el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" router
				:default-active="$route.path">
				<el-menu-item index="/userInfo">
					<i class="el-icon-user-solid"></i>
					<span slot="title">个人信息</span>
				</el-menu-item>
				<el-menu-item index="/working">
					<i class="el-icon-document"></i>
					<span slot="title">工作经验</span>
				</el-menu-item>
				<el-menu-item index="/zjz">
					<i class="el-icon-document"></i>
					<span slot="title">证书</span>
				</el-menu-item>
				<!-- 
				<el-menu-item index="/Todo">
					<i class="el-icon-location"></i>
					<span slot="title">待办事项</span>
				</el-menu-item>
				<el-menu-item index="/immediate-match">
					<i class="el-icon-menu"></i>
					<span slot="title">即时撮合</span>
				</el-menu-item>
				<el-menu-item index="/person-search">
					<i class="el-icon-s-custom"></i>
					<span slot="title">人员检索</span>
				</el-menu-item>
				<el-menu-item index="/job-search">
					<i class="el-icon-setting"></i>
					<span slot="title">岗位检索</span>
				</el-menu-item>
				<el-menu-item index="/personnel-demand">
					<i class="el-icon-set-up"></i>
					<span slot="title">人员需求管理</span>
				</el-menu-item>
				<el-menu-item index="/personnel-redundancy">
					<i class="el-icon-bangzhu"></i>
					<span slot="title">人员冗余管理</span>
				</el-menu-item> -->
			</el-menu>
			<div class="flex-row-start-center"
				style="position: fixed;bottom: 0px;left: 0px;width: 200px;height: 50px;padding: 0px 25px;box-sizing: border-box;"
				@click="bindLogout">
				<i class="el-icon-switch-button"></i>
				<span slot="title" style="margin-left: 10px;">登出</span>
			</div>
			<div class="content">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				userName: "",
				password: "",
				showPassword: false, // 控制密码显示/隐藏
				topImage: require('@/assets/banner_top_def.png'),
			}
		},
		created() {
			console.log("登入后页面");
		},
		computed: {},

		methods: {
			bindLogout() {
				localStorage.setItem('isLoggedIn', 'false')
				localStorage.setItem('isLoggeduserId', '')
				localStorage.setItem('isLoggedIncompanyId', '')
				this.$router.push("/Login");
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-image{
		width: 100%;
	}
	/deep/ .el-image__inner {
		width: 100%;
		height: 100%;
	}
	.top-img {
		height: 150px;
	}

	.container {
		display: flex;
		/* height: 100vh; */
	}

	.el-menu-vertical-demo {
		width: 200px;
		height: 100%;
	}

	.content {
		flex: 1;
		padding: 20px;
		overflow: auto;
	}
</style>